export default __webpack_public_path__ + "static/media/optimization.24dc20e5.svg";